module.exports = "<div class=\"modal-header\">\n    <span class=\"icon icon-delete-circle\" ng-click=\"makeChangesModal.closeModal();\"></span>\n</div>\n\n<div class=\"modal-body\">\n\t<p class=\"modal-title\">Make Changes</p>\n\t<div ng-include=\"'app/appDetail/makeChangesModal/makeChangesMenu.html'\"></div>\n    <ng-include ng-if=\"makeChangesModal.getTemplate() !== ''\" src=\"makeChangesModal.getTemplate()\"></ng-include>\n</div>\n";


//////////////////
// WEBPACK FOOTER
// ./src/app/appDetail/makeChangesModal/makeChangesModal.html
// module id = 589
// module chunks = 1